/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, OnInit} from '@angular/core';
import {HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {ThirdParty} from '../../_models/third-party';
import {EmptyRP, RemovalPoint} from '../../_models/removal-point';
import {AuthService} from '../../_services/auth.service';
import {RemovalPointService} from '../../_services/removal-point.service';
import {ThirdPartyService} from '../../_services/third-party.service';
import {Helpers} from '../../helpers';
import {ToastrService} from 'ngx-toastr';
import {ActivatedRoute} from '@angular/router';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {DialogHelper} from '../../_helpers/dialog-helper';
import {CREATE} from '../../_enums/constants';
import {DEFAULT, EMBEDDED} from '../../_enums/serializer-groups';
import {AND, EQ} from '../../_enums/operators';
import {I18nService} from '../../_services/i18n.service';

@Component({
  selector: 'app-removal-points',
  styleUrls: ['./removal-points.component.scss'],
  templateUrl: './removal-points.component.html'
})
export class RemovalPointsComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              PROPERTIES                                                                                            ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public thirdPartyId: number;
  public removalPoints: RemovalPoint[];

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              FORMS GROUPS                                                                                          ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public removalPointsFG: FormGroup;

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(
    private authService: AuthService,
    private dialogHelper: DialogHelper,
    private formBuilder: FormBuilder,
    private i18n: I18nService,
    private removalPointService: RemovalPointService,
    private route: ActivatedRoute,
    private thirdPartyService: ThirdPartyService,
    private toastr: ToastrService
  ) {
    this.removalPoints = [];
  }

  ngOnInit() {
    this.thirdPartyId = this.data;
    this.initFG();
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              REMOVAL FORM CONTROLS                                                                                 ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  get data(): number | null {
    if (this.route.snapshot.queryParams.id) {
      return Number(this.route.snapshot.queryParams.id);
    }

    if (this.route.snapshot.params.id) {
      return Number(this.route.snapshot.params.id);
    }

    return null;
  }

  get thirdPartyFC(): FormArray {
    return this.removalPointsFG.get('thirdParty') as FormArray;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              FORMS INITIALISATION                                                                                  ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  private initFG() {
    this.removalPointsFG = this.formBuilder.group({
      thirdParty: this.thirdPartyId
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              LISTENERS                                                                                             ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public showAddForm(): void {
    this.dialogHelper.showRemovalPointForm({
      mode: CREATE,
      removalPoint: EmptyRP(),
      thirdPartyId: this.thirdPartyId
    }).subscribe((res: RemovalPoint) => {
      if (res) {
        this.loadRemovalPoints();
      }
    });
  }

  public tpChange(e: ThirdParty): void {
    this.thirdPartyId = e.id;
    this.loadRemovalPoints();
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              ASYNC LOAD                                                                                            ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public loadRemovalPoints() {
    Helpers.setLoading(true);
    this.removalPointService.find({
      filter: [['thirdParty', EQ, this.thirdPartyFC.value], AND, ['headquarter', EQ, false]],
      serializerGroups: [DEFAULT, EMBEDDED],
      sort: [{selector: 'favorite', desc: true}, {selector: 'enabled', desc: true}]
    }).subscribe((res: HttpResponse<Array<RemovalPoint>>) => {

      this.removalPoints = res.body;
      Helpers.setLoading(false);
    }, (err: HttpErrorResponse) => this.handleError(err));

  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              PRIVATE METHODS                                                                                       ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  private handleError(err: HttpErrorResponse): void {
    Helpers.setLoading(false);
    this.toastr.error(`${err.status} - ${this.i18n.get(err.status)}`);
  }

}
